import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/unit-types/save`,
        endpointGetById: `${endpointBackend}gci/unit-types/getById`,
        urlGoBack: `/gci/unit-types/list`,
        pathView: `/gci/unit-types/view`
    }

    const labels = {
        labelTitleAdd: "Novo Tipo de Unidade",
        labelTitleEdit: "Editar Tipo de Unidade",
        labelTitleView: 'Visualizar Tipo de Unidade'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'unit_type',
                    type: 'text',
                    label: 'Tipo de Unidade',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'identification_levels',
                    type: 'multicheckbox',
                    options: [
                        { label: 'Bloco/Quadra', value: 'hasBlock' },
                        { label: 'Piso/Andar', value: 'hasFloor' },
                        { label: 'Número', value: 'hasNumber' }
                    ],
                    switch: false,
                    showSelectAll: true,
                    label: 'Configuração de Identificação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
